var _path, _g, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDropPdf = function SvgDropPdf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 115 159"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 17.885A2.885 2.885 0 0 1 2.885 15h68.584l27.96 35.26c.406.513.626 1.149.624 1.803l-.295 81.572a2.886 2.886 0 0 1-2.885 2.875H2.885A2.885 2.885 0 0 1 0 133.625z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#drop-pdf_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M71.412 15 100 51.052H74.297a2.885 2.885 0 0 1-2.885-2.885z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A9EAB",
    d: "M40.838 76.561h2.799q1.2 0 1.903.612t.703 1.666q0 1.099-.714 1.71-.703.612-1.915.612H41.96v2.198h-1.122zm4.249 2.29q0-.636-.408-.964-.396-.329-1.099-.329h-1.62v2.618h1.632q.702 0 1.098-.329.397-.328.397-.997Zm7.23-1.35q.963.93.963 2.46 0 1.528-.963 2.47-.952.928-2.538.928h-2.402v-6.797h2.402q1.585 0 2.538.94Zm-3.818.057v4.804h1.212q1.054 0 1.733-.645.692-.658.692-1.757 0-1.121-.692-1.756-.679-.645-1.733-.645H48.5Zm10.33 2.844h-3.16v2.957h-1.122v-6.797h4.86v.996h-3.739v1.893h3.161z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M48.94 158.061a1.5 1.5 0 0 0 2.12 0l9.547-9.546a1.5 1.5 0 0 0-2.122-2.122L50 154.879l-8.485-8.486a1.501 1.501 0 0 0-2.122 2.122zM48.5 111v46h3v-46z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "drop-pdf_svg__a",
    width: 57.437,
    height: 64.901,
    x: 56.987,
    y: 0.575,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.212
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.258824 0 0 0 0 0.486275 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_66_11698"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_66_11698",
    result: "shape"
  })))));
};
export { SvgDropPdf as ReactComponent };